import styled from 'styled-components';

export const ErrorContainer = styled.div`
  background: #eae8e9;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorMessage = styled.div`
  color: #666;
  font-size: 16px;
`; 